
import { Component, Vue } from "vue-property-decorator";
import GeneralFooter from "@/components/general-footer.vue";
import { Getter, Mutation } from "vuex-class";
import { SinglePagePayload } from "@/store/mutations";
import { FormValues } from "@/interfaces/FormValues";
import { DATEN_ROUTE_NAME } from "@/router";
import { PAGE_NAMES } from "@/constants/form-page-names";
import { CHARACTERISTICS_FIELD_NAMES } from "@/constants/form-field-names";

@Component({
  components: {
    GeneralFooter,
  },
})
export default class Auspraegung extends Vue {
  public form_values: FormValues = {};

  @Getter("allFormValues")
  allFormValues!: Record<string, FormValues>;

  @Mutation("setFormValues")
  setFormValues!: (payload: SinglePagePayload) => void;

  FIELD_NAMES = CHARACTERISTICS_FIELD_NAMES;

  mounted() {
    // load from store or set default values
    this.form_values = this.allFormValues[PAGE_NAMES.characteristics] || {};
  }

  optionsArray1 = [
    {
      value: "Portrait (Hoch)",
      label: "Portrait (Hoch)",
    },
    {
      value: "Landscape (Quer)",
      label: "Landscape (Quer)",
    },
    {
      value: "LED Wall",
      label: "LED Wall",
    },
    {
      value: "Nicht vorhanden",
      label: "Nicht vorhanden",
    },
  ];

  optionsArray2 = [
    {
      value: "Portrait (Hoch)",
      label: "Portrait (Hoch)",
    },
    {
      value: "Landscape (Quer)",
      label: "Landscape (Quer)",
    },
    {
      value: "Nicht vorhanden",
      label: "Nicht vorhanden",
    },
  ];

  optionsWebsite = [
    {
      value: "Video mit Ton",
      label: "Video mit Ton",
    },
    {
      value: "Video ohne Ton",
      label: "Video ohne Ton",
    },
    {
      value: "Teaser klein",
      label: "Teaser klein",
    },
    {
      value: "Teaser gross",
      label: "Teaser gross",
    },
  ];

  optionsFacebook = [
    {
      value: "Titelbild",
      label: "Titelbild",
    },
    {
      value: "Beitrag",
      label: "Beitrag",
    },
    {
      value: "Story",
      label: "Story",
    },
    {
      value: "Reel",
      label: "Reel",
    },
  ];

  optionsInstagram = [
    {
      value: "Beitrag",
      label: "Beitrag",
    },
    {
      value: "Story",
      label: "Story",
    },
    {
      value: "Reel",
      label: "Reel",
    },
  ];

  optionsTikTok = [
    {
      value: "Story",
      label: "Story",
    },
    {
      value: "Reel",
      label: "Reel",
    },
  ];

  optionsLinkedIn = [
    {
      value: "Titelbild",
      label: "Titelbild",
    },
    {
      value: "Beitrag",
      label: "Beitrag",
    },
    {
      value: "Story",
      label: "Story",
    },
  ];

  optionsAudio = [
    {
      value: "Ohne Audio",
      label: "Ohne Audio",
    },
    {
      value: "Musik",
      label: "Musik",
    },
    {
      value: "Stimme",
      label: "Stimme",
    },
  ];

  public prev(): void {
    this.$router.go(-1);
  }

  public next(): void {
    this.$router.push({ name: DATEN_ROUTE_NAME });
  }

  public async submit(): Promise<void> {
    const thisPagePayload: SinglePagePayload = {
      PAGE_NAME: PAGE_NAMES.characteristics,
      formValues: this.form_values,
    };

    this.setFormValues(thisPagePayload);
    this.next();
  }
}
